import { render, staticRenderFns } from "./Jobrecruitmentdetailss.vue?vue&type=template&id=4e185808&scoped=true&"
import script from "./Jobrecruitmentdetailss.vue?vue&type=script&lang=js&"
export * from "./Jobrecruitmentdetailss.vue?vue&type=script&lang=js&"
import style0 from "./Jobrecruitmentdetailss.vue?vue&type=style&index=0&id=4e185808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e185808",
  null
  
)

export default component.exports